import React, { PureComponent } from 'react';
import ModifierContentBuilder from './ModifierContentBuilder';
import ModifierContent from './ModifierContent';

class ModifierInput extends React.Component {
  constructor(props) {
    super(props);
    this.handleBuilderChange = this.handleBuilderChange.bind(this);
  }

  handleSelectedChange = event => {
    const { modifier, onSelectedChange } = this.props;
    onSelectedChange && onSelectedChange(modifier);
  };

  handleBuilderChange = (field, item) => {
    let { modifier, onModifierChange } = this.props;
    modifier[field] = item;
    if (onModifierChange) onModifierChange(modifier);
  };

  render() {
    const { modifier, type, partialServingPricing, name } = this.props;
    return (
      <label className="pizzaCreatorModifierSelect">
        <input
          id={modifier.id}
          type={type}
          name={type === 'radio' && name}
          value={modifier.id}
          onChange={this.handleSelectedChange}
          className="pickupTimeRadio"
          checked={modifier.selected}
        />
        {/* Below code is important for custom rendering checkbox or radio button. */}
        <span>
          <span />
        </span>
        {modifier.use_builder ? (
          <ModifierContentBuilder
            modifier={modifier}
            partialServingPricing={partialServingPricing}
            onChange={this.handleBuilderChange}
          />
        ) : (
          <ModifierContent modifier={modifier} />
        )}
      </label>
    );
  }
}

export default ModifierInput;



// WEBPACK FOOTER //
// ./src/views/dashboard/components/items/components/PizzaCreatorModifiers/ModifierInput/index.jsx